import { IconButton, Stack, Typography, useTheme } from '@mui/material';
import { TitleCountStyled, TopBarStyled } from './top-bar.styled';

import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { IconSize } from '@constants';

interface Props {
  title: React.ReactNode | string;
  navigateToBack?: () => void;
  count?: number;
  children?: React.ReactNode;
}

export const TopBar = ({ children, title, navigateToBack, count }: Props) => {
  const theme = useTheme();
  return (
    <TopBarStyled>
      <Stack direction={'row'} alignItems={'center'} gap={2}>
        {navigateToBack ? (
          <IconButton onClick={navigateToBack}>
            <ArrowLeftIcon
              width={IconSize.md}
              color={theme.palette.primary.main}
            />
          </IconButton>
        ) : (
          <></>
        )}
        <Stack direction={'row'} gap={1}>
          {typeof title === 'string' && (
            <Typography variant="h2">{title}</Typography>
          )}

          {typeof title !== 'string' && title}
          {count !== undefined ? (
            <TitleCountStyled variant="caption">[{count}]</TitleCountStyled>
          ) : (
            <></>
          )}
        </Stack>
      </Stack>
      {children}
    </TopBarStyled>
  );
};
